const state = {
  newsPage: {
    currentPage: 1,
    pageSize: 5,
    total: 0
  },
  newsList: []
}
const getters = {
  getNewsPage: state => {
    return state.newsPage
  },
  getNewsList: state => {
    if (state.newsList == null || state.newsList.length == 0) {
      let temp = sessionStorage.getItem('newsList')
      temp = JSON.parse(temp)
      if (temp != null && temp.length > 0) {
        state.newsList = temp
      } else {
        state.newsList = []
      }
    }
    return state.newsList
  }
}
const mutations = {
  NEWS_PAGE_STATUS(state, page) {},
  NEWS_LIST_STATUS(state, list) {
    if (Array.isArray(list)) {
      state.newsList = list
      sessionStorage.setItem('newsList', JSON.stringify(state.newsList))
    } else {
      state.newsList = []
      sessionStorage.removeItem('newsList')
    }
  }
}
const actions = {
  setNewsPage({ commit }, page) {
    commit('NEWS_PAGE_STATUS', page)
  },
  setNewsList({ commit }, list) {
    commit('NEWS_LIST_STATUS', list)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/new-list.js